const translations = {
  English: {
    greet:'WELCOME TO',
    Title:'Shrimad Rajchandra Ashram, Dharampur',
    nameMustBeUnique:'Full Name should be Unique',
    PhnMustBeUnique:'Mobile Number should be Unique',
    ashramEntry: `Day Visitor - Ashram Entry Pass`,
    visitor: "Visitor",
    addGuest: "Add another Guest",
    getQRCode: (n) => `Get QR Code for ${n} visitors`,
    getNoData: (n) => `No ${n} Data Found`,
    NoTData:`No Transaction History Data Found`,
    NoSData:`No Scanning History Data Found`,
    submit:'Submit',
    dashboard:'Dashboard',
    buggy:'Buggy',
    cbuggy:'BUGGY',
    buggyContent:'As the Ashram is spread across a vast land of 223 acres, it is recommended that you purchase buggy passes for easy commute around the Ashram.',
    subTotal:'Subtotal',
    payOnline:'Pay Online',
    Note:'Please Note: Buggy Passes/Coupons can be purchased offline as well from the Registration Office.',
    mealTitle:'Meals',
    purchaseC:'Purchase coupons for meals at the Ashram',
    buyDailyPass:'Buy Daily Pass',
    fullName: "Full Name",
    city: "City",
    gender: "Gender",
    selectGender: "Select your gender",
    male: "Male",
    female: "Female",
    other: "Other",
    age: "Age",
    mobile: "Mobile Number",
    mobilePlaceholder: "Enter your mobile number",
    genderOptions: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
    ],
    memberFound: "We found your details associated with this mobile number.",
    nextBtn: "Next",
    prvBtn: "Prev",
    TravelQ: "FOR EASY TRAVEL IN THE ASHRAM",
    TravelSecQ: "Purchase Buggy Passes",
    THistory:'Transaction History',
    SHistory:'Scanning History',
    Buy: "Buy Now",
    MealsQ: "Buy Meals In The Ashram",
    DailyPasses:'Daily Passes',
    meals: {
      breakfast: "BREAKFAST",
      'vegan breakfast': "VEGAN BREAKFAST",
      lunch: "LUNCH",
      'vegan lunch': "VEGAN LUNCH",
      dinner: "DINNER",
      'vegan dinner': "VEGAN DINNER",
      breakfastSDescription: "Breakfast",
      veganBreakfastSDescription: "Vegan Breakfast",
      lunchSDescription: "Lunch",
      veganLunchSDescription: "Vegan Lunch",
      dinnerSDescription: "Dinner",
      veganDinnerSDescription: "Vegan Dinner",
      'buggy pass':'BUGGY DAILY PASS',
      quote: "Purchase Meal Coupons",
      media: "ON WHATSAPP",
      Button: "Open WhatsApp",
      meal:'Meals',
      all:'All',
      no:'No Meals Available At This Time'
    },
    Ashram: {
      tour: "Ashram Tour",
      Schedule: "Ashram Schedule",
      Culture: " Ashram Culture",
      cancel: "Cancel Ashram Tour",
      cancelPopup:'Are you sure you want to cancel your',
      cancelPopupTwo:'booking for the above Ashram Tour?',
      cancelBtn:'yes, Cancel'
    },
    TourLine:'Explore the beauty of the Ashram and its legacy that each corner holds (Free of cost)',
    AshramTourLine:'Book a slot for taking an Ashram Tour',
    AshramTourLineNote:'Note: Please reach the location 15 mins prior to your slot.',
    AshramTourBook:(n) => `Ashram Tour ${n} Booked`,
    People:'Visitor',
    Peoples:'Visitors',
    welcome:'WelCome Center',
    BookAgain:'Book Another Tour',
    TourButton:'Book Now',
    BookButton:'Book',
    ProceedButton:'Proceed',
    BackButton:'Back',
    CountLine:'Enter count for Ashram Tour',
    BookHeadingFirst:'You will have to report at',
    BookHeadingSec:(n) =>`${n} 15 mins before the tour.`,
    Coupons:'COUPONS',
    Coupon:'COUPON',
    each:'each',
    Amountpaid:'Amount Paid',
    HeadLine:'All purchased services will be added to your QR code.',
    Lastvisited:'Last visited',
    View:'View All',
    cityValidate:'City Name Length can not be more than 50',
    mobValidate: (n, m) => 
      n === m 
        ? `Mobile Number should be ${n} digits` 
        : `Mobile Number should be in between ${n} to ${m} digits`,
    DbuggyPass:'Buggy Daily Passes',
    noteForMobile:'Note: For young children and elders without a phone, leave the mobile number field blank.',
    OfflineMessage:'You are offline. Check your network connection.',
    OnlineMessage:'Back online!',
    voiceError: (n) => `visitor #${n} Name voice is currently active. Please turn it off.`,
    nameError:'City voice is currently active. Please turn it off.',
    MealsTimingHead:'Meal Timings and Information',
    MealsTimingNote:'Note: Dinner timings change as per sunset',
    noteForChintanShibir:
      "Since the Ashram will be hosting Shri Rajnath Singhji, Hon’ble Defence Minister of India, entry to the premises will be restricted on 27th December. We kindly request everyone to plan their visit after 27th December.",
  },
  Gujarati: {
    greet: 'સ્વાગત છે',
    Title: 'શ્રીમદ રાજચંદ્ર આશ્રમ, ધરમપુર',
    nameMustBeUnique:'પૂરું નામ અનન્ય હોવું જોઈએ',
    PhnMustBeUnique:'મોબાઇલ નંબર અનન્ય હોવું જોઈએ',
    ashramEntry:`દિવસ મુલાકાતી -આશ્રમ પ્રવેશ પાસ`,
    visitor: "મુલાકાતી",
    addGuest: "અન્ય મુલાકાતી",
    getQRCode: (n) => `${n} મુલાકાતીઓ માટે ક્યુઆર કોડ મેળવો`,
    getNoData: (n) => `કોઈ ${n} ડેટા મળ્યો નથી`,
    NoTData:`લેણદેણની કોઈ માહિતી નથી`,
    NoSData:`સ્કેનિંગની કોઈ માહિતી નથી`,
    submit:'સબમિટ કરો',
    dashboard:'ડેશબોર્ડ',
    buggy:'બગી',
    cbuggy:'બગી',
    buggyContent:'આશ્રમ 223 એકરની વિશાળ જમીનમાં ફેલાયેલો હોવાથી, આશ્રમમાં આપની મુસાફરી સરળ કરવા માટે બગી પાસ ખરીદવાની ભલામણ કરવામાં આવે છે.',
    subTotal:'સબ-ટોટલ',
    payOnline:'ઓનલાઇન ભુગતાન',
    Note:'મહેરબાની કરીને નોંધ કરો: બગી પાસ/કૂપન રજિસ્ટ્રેશન ઑફિસમાંથી ઑફલાઇન પણ ખરીદી શકાય છે.',
    mealTitle:'ભોજન',
    purchaseC:'આશ્રમમાં ભોજન માટે કૂપન ખરીદો',
    buyDailyPass:'દૈનિક પાસ ખરીદો',
    fullName: "પૂરું નામ",
    city: "શહેર",
    gender: "જાતિ",
    selectGender: "તમારું લિંગ પસંદ કરો",
    male: "પુરુષ",
    female: "સ્ત્રી",
    other: "અન્ય",
    age: "ઉંમર",
    mobile: "મોબાઇલ નંબર",
    mobilePlaceholder: "તમારો મોબાઇલ નંબર લખો",
    genderOptions: [
      { value: "male", label: "પુરુષ" },
      { value: "female", label: "સ્ત્રી" },
    ],
    memberFound: "અમને  આ મોબાઈલ નંબર સાથે સંકળાયેલી તમારી વિગતો મળી છે.",
    nextBtn: "આગળ",
    prvBtn: "અગાઉના",
    TravelQ: "આશ્રમમાં સરળ મુસાફરી માટે",
    TravelSecQ: "બગડેલ પાસ ખરીદો",
    THistory:'લેણદેણની માહિતી',
    SHistory:'સ્કેનિંગની માહિતી',
    Buy: "ખરીદો",
    MealsQ: "આશ્રમમાં ભોજન ખરીદો",
    DailyPasses:'દૈનિક પાસ',
    meals: {
      breakfast: "અલ્પાહાર",
      'vegan breakfast': "વેગન અલ્પાહાર",
      lunch: "બપોરનું ભોજન",
      'vegan lunch': "વેગન બપોરનું ભોજન",
      dinner: "સાંજનું ભોજન",
      'vegan dinner': "વેગન સાંજનું ભોજન",
      breakfastSDescription: "અલ્પાહાર",
      veganBreakfastSDescription: "વેગન અલ્પાહાર",
      lunchSDescription: "બપોરનું ભોજન",
      veganLunchSDescription: "વેગન બપોરનું ભોજન",
      dinnerSDescription: "સાંજનું ભોજન",
      veganDinnerSDescription: "વેગન સાંજનું ભોજન",
      'buggy pass':'દૈનિક બગી પાસ',
      quote: "મીલ કૂપન ખરીદો",
      media: "વ્હાટ્સએપ પર",
      Button: "WhatsApp ખોલો",
      meal:'ભોજન',
      all:'બધું',
      no:'આ સમયે કોઈ ભોજન ઉપલબ્ધ નથી'
    },
    Ashram: {
      tour: "આશ્રમ પર્યટન",
      Schedule: "આશ્રમ કાર્યક્રમ",
      Culture: "આશ્રમ સંસ્કૃતિ",
      cancel: "આશ્રમ પ્રવાસ રદ કરો",
      cancelPopup: 'શું તમે ખરેખર તમારી બુકિંગ રદ કરવા માંગો છો',
      cancelPopupTwo: 'ઉપરોક્ત આશ્રમ પ્રવાસ માટે?',
      cancelBtn:'હા, રદ કરો'
    },
    TourLine:'આશ્રમની સુંદરતાનું અન્વેષણ કરો અને તેના વારસાને અન્વેષણ કરો જે દરેક ખૂણે ધરાવે છે (વિનામૂલ્યે)',
    Coupons:'કૂપન',
    Coupon:'કૂપન',
    each:'દરેક',
    Amountpaid:'ચૂકવેલ રકમ',
    HeadLine:'ખરીદેલી બધી સેવાઓ તમારા QR કોડમાં ઉમેરવામાં આવશે.',
    Lastvisited:'છેલ્લી મુલાકાત',
    View:'બધું જુવો',
    cityValidate:'શહેરનું નામ 50 અક્ષરોથી વધુ નથી',
    mobValidate: (n, m) => 
      n === m 
        ? `મોબાઇલ નંબર ${n} અંકોનો હોવો જોઈએ` 
        : `મોબાઇલ નંબર ${n} થી ${m} અંકોની વચ્ચે હોવો જોઈએ`,
    DbuggyPass:'દૈનિક બગી પાસ',
    noteForMobile:'નોંધ: નાના બાળકો અને વૃદ્ધો જેઓ પાસે ફોન નથી, માટે મોબાઇલ નંબર ફીલ્ડ ખાલી રાખો.',
    OfflineMessage:'તમે ઑફલાઇન છો. તમારું નેટવર્ક કનેક્શન તપાસો.',
    OnlineMessage:'પાછા ઑનલાઇન!',
    voiceError: (n) => `મુલાકાતી #${n} નું નામ વોઈસ હાલમાં સક્રિય છે. કૃપા કરીને તેને બંધ કરો.`,
    nameError: 'શહેરનું વોઈસ હાલમાં સક્રિય છે. કૃપા કરીને તેને બંધ કરો.',
    MealsTimingHead:'ભોજન સમય અને માહિતી',
    MealsTimingNote:'નોંધ: રાત્રીના ભોજનના સમય સૂર્યાસ્તના સમય મુજબ બદલાય છે.',
    TourButton:'હવે બુક કરો',
    AshramTourLine:'આશ્રમની ટૂર લેવા માટે સ્લોટ બુક કરો',
    AshramTourLineNote:'નોંધ: કૃપા કરીને તમારા સમય પત્રક પહેલા 15 મિનિટે સ્થળ પર પહોંચી જાઓ.',
    BookButton:'બુક',
    BookHeadingFirst: 'તમારે નીચેના સ્થળ પર હાજરી આપવી પડશે:',
    BookHeadingSec: (n) => `${n} પર પ્રવાસ પહેલા 15 મિનિટે પહોંચી જશો.`,
    ProceedButton:'આગળ વધો',
    BackButton:'પાછળ',
    AshramTourBook:(n) => `આશ્રમ ટુર ${n} બુક કર્યું`,
    People:'મુલાકાતી',
    Peoples:'મુલાકાતીઓ',
    BookAgain:'બીજી ટુર બુક કરો',
    CountLine:'આશ્રમ પ્રવાસ માટે ગણતરી દાખલ કરો',
    noteForChintanShibir:
      "આશ્રમમાં ભારતના માનનીય રક્ષા મંત્રી શ્રી રાજનાથ સિંહજીના આગમનને કારણે 27 ડિસેમ્બરના રોજ આશ્રમ પરિસરમાં પ્રવેશ પ્રતિબંધિત રહેશે.સૌને વિનમ્ર વિનંતી છે કે કૃપા કરીને 27 ડિસેમ્બર પછી પોતાની મુલાકાતનું આયોજન કરશો."
  },
  Hindi: {
    greet: 'स्वागत है',
    Title: 'श्रीमद राजचंद्र आश्रम, धरमपुर',
    nameMustBeUnique:'पूरा नाम अनोखा होना चाहिए',
    PhnMustBeUnique:'मोबाइल नंबर अनोखा होना चाहिए',
    ashramEntry:`दैनिक आगंतुक - आश्रम प्रवेश पास`,
    visitor: "मुलाकाती",
    addGuest: "अन्य मुलाकाती",
    getQRCode: (n) => `${n} आगंतुकों के लिए क्यूआर कोड प्राप्त करें`,
    getNoData: (n) => `कोई ${n} डेटा नहीं मिला`,
    NoTData:`कोई ट्रांजेक्शन डेटा नहीं मिला`,
    NoSData:`स्केनिंगकी कोई माहिती नहीं है`,
    submit:'सबमिट करें',
    dashboard:'डैशबोर्ड',
    buggy:'बग्गी',
    cbuggy:'बग्गी',
    buggyContent:'आश्रम 223 एकड़ की विशाल भूमि में फैला हुआ है, इसलिए यह अनुशंसा की जाती है कि आप आश्रममें आसान आवागमन के लिए बग्गी पास खरीदें।',
    mealTitle:'भोजन',
    purchaseC:'आश्रम में भोजन के लिए कूपन खरीदें',
    subTotal:'सब-टोटल',
    payOnline:'ऑनलाइन पेमेंट करें',
    Note:'कृपया ध्यान दें: बग्गी पास/कूपन पंजीकरण कार्यालय से ऑफ़लाइन भी खरीदे जा सकते हैं।',
    buyDailyPass:'दैनिक पास खरीदें',
    fullName: "पूरा नाम",
    city: "शहर",
    gender: "लिंग",
    selectGender: "अपना लिंग चुनें",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    age: "आयु",
    mobile: "मोबाइल नंबर",
    mobilePlaceholder: "अपना मोबाइल नंबर दर्ज करें",
    genderOptions: [
      { value: "male", label: "पुरुष" },
      { value: "female", label: "महिला" },
    ],
    memberFound: "हमें इस मोबाइल नंबर से जुड़ी आपकी जानकारी मिली है।",
    Lastvisited:'पिछली मुलाकात',
    nextBtn: "अगला",
    prvBtn: "पहले",
    TravelQ: "आश्रम में आसान यात्रा के लिए",
    TravelSecQ: "छोटी गाड़ी वाले पास खरीदें",
    THistory:'लेन-देनकी माहिती',
    SHistory:'स्केनिंगकी माहिती',
    Buy: "खरीदें",
    MealsQ: "आश्रम में भोजन खरीदें",
    DailyPasses:'दैनिक पास',
    meals: {
      breakfast: "अल्पाहार",
      'vegan breakfast': "विगन अल्पाहार",
      lunch: "दोपहरका भोजन",
      'vegan lunch': "विगन दोपहरका भोजन",
      dinner: "सायं भोजन",
      'vegan dinner': "विगन सायं भोजन",
      breakfastSDescription: "अल्पाहार",
      veganBreakfastSDescription: "विगन अल्पाहार",
      lunchSDescription: "दोपहरका भोजन",
      veganLunchSDescription: "विगन दोपहरका भोजन",
      dinnerSDescription: "सायं भोजन",
      veganDinnerSDescription: "विगन सायं भोजन",
      'buggy pass':'दैनिक बग्गी पास',
      quote: "मील कूपन खरीदें",
      media: "व्हाट्सएप पर",
      Button: "व्हाट्सएप खोलें",
      meal:'भोजन',
      all:'सभी',
      no:'इस समय भोजन उपलब्ध नहीं है'
    },
    Ashram: {
      tour: "आश्रम भ्रमण",
      Schedule: "आश्रम कार्यक्रम",
      Culture: "आश्रम संस्कृति",
      cancel: "आश्रम यात्रा रद्द करें",
      cancelPopup: 'क्या आप वाकई अपनी बुकिंग रद्द करना चाहते हैं',
      cancelPopupTwo: 'उपरोक्त आश्रम यात्रा के लिए?',
      cancelBtn:'हाँ, रद्द करें'
    },
    TourLine:'आश्रम की सुंदरता का अन्वेषण करें और इसकी विरासत का पता लगाएं जो प्रत्येक कोने में मौजूद है (निःशुल्क)',
    Coupons:'कूपन',
    Coupon:'कूपन',
    each:'प्रत्येक',
    Amountpaid:'भुगतान की गई राशि',
    HeadLine:'खरीदी गई सभी सेवाएँ आपके QR कोड में जोड़ दी जाएंगी।',
    View:'सभी देखें',
    cityValidate:'शहर का नाम 50 अक्षरों से अधिक नहीं हो सकता',
    mobValidate: (n, m) => 
      n === m 
        ? `मोबाइल नंबर ${n} अंकों के होना चाहिए` 
        : `मोबाइल नंबर ${n} से ${m} अंकों के बीच होना चाहिए`,
    DbuggyPass:'दैनिक बग्गी पास',
    noteForMobile:'नोट: छोटे बच्चों और बुजुर्गों के लिए जिनके पास फोन नहीं है, मोबाइल नंबर फील्ड खाली छोड़ दें।',
    OfflineMessage:'आप संपर्क में नहीं हैं। अपना नेटवर्क कनेक्शन जांचें.',
    OnlineMessage:'वापस ऑनलाइन!',
    voiceError: (n) => `आगंतुक #${n} का नाम वॉइस वर्तमान में सक्रिय है। कृपया इसे बंद करें।`,
    nameError: 'शहर की वॉइस वर्तमान में सक्रिय है। कृपया इसे बंद करें।',
    MealsTimingHead:'भोजन समय और जानकारी',
    MealsTimingNote:'नोट: रात्रि भोजन के समय सूर्यास्त के समय के अनुसार बदलते हैं।',
    TourButton:'अभी बुक करें',
    AshramTourLine:'आश्रम भ्रमण के लिए एक स्लॉट बुक करें',
    AshramTourLineNote:'नोट: कृपया अपने स्लॉट से 15 मिनट पहले स्थान पर पहुँचें।',
    BookButton:'बुक',
    BookHeadingFirst: 'आपको निम्नलिखित स्थान पर रिपोर्ट करना होगा:',
    BookHeadingSec: (n) => `यात्रा से 15 मिनट पहले ${n} पर पहुँचें।`,
    ProceedButton:'आगे बढ़ना',
    BackButton:'पीछे',
    AshramTourBook:(n) => `आश्रम टूर ${n} बुक किया`,
    People:'आगंतुक',
    Peoples:'आगंतुकों',
    BookAgain:'एक और यात्रा बुक करें',
    CountLine:'आश्रम यात्रा के लिए गिनती दर्ज करें',
    noteForChintanShibir:
      "चूँकि आश्रम में भारत के माननीय रक्षा मंत्री श्री राजनाथ सिंह जी का आगमन होने वाला है, इसलिए 27 दिसंबर को आश्रम परिसर में प्रवेश प्रतिबंधित रहेगा| हम सभी से विनम्र अनुरोध करते हैं कि कृपया 27 दिसंबर के बाद अपनी यात्रा की योजना बनाएँ।"
  },
};

export default translations;
